import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import ContactUsView from "@/views/ContactUsView.vue";
import RehvidView from "@/views/RehvidView.vue";
import Auto24 from "@/views/Auto24.vue";
import Hinnakiri from "@/views/Hinnakiri.vue";
import BookingView from "@/views/BookingView.vue";

const redirectLegacyHashRoute = () => {
  if (typeof window === "undefined") return;

  const { hash } = window.location;
  if (!hash.startsWith("#/")) return;

  window.history.replaceState(null, "", hash.slice(1));
};

redirectLegacyHashRoute();

const routes = [
  { path: "/", name: "Home", component: HomeView },
  { path: "/contactus", name: "ContactUs", component: ContactUsView },
  { path: "/rehvid", name: "Rehvid", component: RehvidView },
  { path: "/auto24", name: "Auto24", component: Auto24 },
  {
    path: "/hinnakiri",
    name: "Hinnakiri",
    component: Hinnakiri,
  },
  { path: "/booking", name: "Booking", component: BookingView },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
